import moment from 'moment'

export function formatTime(isoString, showDate = true) {
  if (!isoString) return ''
  const date = moment(isoString)
  if (showDate) {
    return date.format('DD/MM/YYYY, hh:mm A')
  } else {
    return date.format('hh:mm A')
  }
}

export const formatDate = (iso) => {
  const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }
  return new Date(iso).toLocaleDateString(undefined, options)
}

export const getDaysRemaining = (expirationDate) => {
  if (!expirationDate) return 0
  const expiration = moment(expirationDate)
  const now = moment()
  return Math.max(0, expiration.diff(now, 'days'))
}

export const formatRemainingTime = (expirationDate) => {
  if (!expirationDate) return 'Expired'
  const expiration = moment(expirationDate)
  const now = moment()

  return moment.duration(expiration.diff(now)).humanize()
}

export const isExpired = (expirationDate) => {
  if (!expirationDate) return true
  return moment().isAfter(moment(expirationDate))
}
